import { IMG_URL } from "../components/common/Constant";
let booking_details;
let bundle_bg_url;
/**
 * Calculate discounted amounts for cover and entry prices
 * @param coverPrice - Original cover price
 * @param entryPrice - Original entry price
 * @param discountValue - Discount value (percentage or absolute)
 * @param discountType - Type of discount ('percentage', 'absolute', or other)
 * @returns Object containing discounted cover and entry amounts
 */
export const calculateDiscountedPrices = (coverPrice, entryPrice, discountValue, discountType) => {
    const safeNum = (val) => (isFinite(Number(val)) ? Number(val) : 0);
    const safeCover = safeNum(coverPrice);
    const safeEntry = safeNum(entryPrice);
    const safeDiscount = safeNum(discountValue);
    // No discount or invalid discount
    if (safeDiscount <= 0 || discountType === "none") {
        return { discountedCover: safeCover, discountedEntry: safeEntry };
    }
    const totalOriginal = safeCover + safeEntry;
    if (totalOriginal === 0) {
        return { discountedCover: 0, discountedEntry: 0 };
    }
    if (discountType === "percentage") {
        // Apply percentage discount to each amount individually
        return {
            discountedCover: Math.round(safeCover * (1 - safeDiscount / 100)),
            discountedEntry: Math.round(safeEntry * (1 - safeDiscount / 100)),
        };
    }
    else {
        // For absolute discount, split proportionally
        const coverRatio = safeCover / totalOriginal;
        const entryRatio = safeEntry / totalOriginal;
        return {
            discountedCover: Math.round(safeCover - safeDiscount * coverRatio),
            discountedEntry: Math.round(safeEntry - safeDiscount * entryRatio),
        };
    }
};
export const getEventBookingDetails = () => {
    return booking_details;
};
export const setEventBookingDetails = (details) => {
    booking_details = details;
};
export const getBundleBgUrl = () => {
    return bundle_bg_url;
};
export const setBundleBgUrl = (url) => {
    bundle_bg_url = url;
};
export const isBookingClosed = (bookingCloseTime) => {
    if (!bookingCloseTime) {
        return false;
    }
    const now = new Date();
    let bookingClose;
    if (Array.isArray(bookingCloseTime) && bookingCloseTime.length >= 5) {
        const [year, month, day, hour, minute] = bookingCloseTime;
        bookingClose = new Date(year, month - 1, day, hour || 0, minute || 0);
    }
    else if (typeof bookingCloseTime === "string") {
        bookingClose = new Date(bookingCloseTime);
    }
    else {
        return false;
    }
    return now > bookingClose;
};
export const isBookingAllowed = (event) => {
    if (event) {
        const currentDate = new Date();
        const eventEndDate = new Date(event.data.event_end_date);
        return (eventEndDate > currentDate &&
            event.data.is_active &&
            event.data.booking_allowed);
    }
};
export const capitalizeFirstLetter = (str) => {
    if (str)
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    else
        return str;
};
export const formatOfferDate = (date, time) => {
    const inputDate = new Date(date + `, ` + time);
    inputDate.setFullYear(new Date().getFullYear());
    const formattedDate = [
        inputDate
            .toLocaleDateString("en-UK", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })
            .split("/")
            .reverse()
            .join("-"),
        inputDate.toLocaleTimeString("en-UK", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        }),
    ].join(" ");
    return formattedDate;
};
export const formateDate = (date) => {
    return date.toLocaleDateString("en-US", {
        weekday: "long",
        month: "short",
        day: "numeric",
    });
};
export const formateTime = (date) => {
    return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
    });
};
export const personVsPass = {
    Stag: "Regular Pass",
    Ladies: "VIP",
    Couple: "VVIP",
};
export const roundToNearest60 = (date) => {
    const minutes = date.getMinutes();
    const remainder = minutes % 30;
    // If the remainder is more than 15, round up, otherwise round down
    if (remainder > 15) {
        // Round up to the next 30-minute interval
        date.setMinutes(minutes + (60 - remainder));
    }
    else {
        // Round down to the previous 30-minute interval
        date.setMinutes(minutes - remainder);
    }
    // Set seconds and milliseconds to 0 for exact 30-min intervals
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
};
export const DiscountOffersbgLinearGradient = (category) => {
    switch (category) {
        case "TABLE_DISCOUNT":
            return "linear-gradient(180deg, #252525 0%, #1A2038 100%)";
        case "BILL_DISCOUNT":
            return "linear-gradient(180deg, #252525 0%, #331A38 100%)";
        case "COMBOS":
            return "linear-gradient(180deg, #252525 0%, #1A382A 100%)";
        default:
            return "linear-gradient(180deg, #252525 0%, #38371A 100%)";
    }
};
export const convertToAmPm = (timeRange) => {
    if (!timeRange || typeof timeRange !== "string")
        return timeRange;
    const convertSingleTime = (time) => {
        time = time.trim();
        if (!time || !time.includes(":"))
            return time;
        const [hours, minutes] = time.split(":").map(Number);
        const suffix = hours >= 12 ? "PM" : "AM";
        const adjustedHours = hours % 12 || 12;
        const formattedMinutes = minutes === 0 ? "" : `:${minutes.toString().padStart(2, "0")}`;
        return `${adjustedHours}${formattedMinutes}${suffix}`;
    };
    const convertRange = (range) => {
        // Use regex to split by dash with optional spaces
        const parts = range.split(/\s*-\s*/);
        // Handle single time (no range)
        if (parts.length === 1) {
            const time = parts[0].trim();
            return time ? convertSingleTime(time) : "";
        }
        // Handle time range
        if (parts.length !== 2)
            return range.trim();
        const start = parts[0].trim();
        const end = parts[1].trim();
        // Handle incomplete ranges
        if (!start && end) {
            // " - 22:00" -> "Till 10PM"
            return `Till ${convertSingleTime(end)}`;
        }
        if (start && !end) {
            // "18:00 - " -> "From 6PM"
            return `From ${convertSingleTime(start)}`;
        }
        if (!start && !end) {
            return "";
        }
        // Complete range
        return `${convertSingleTime(start)} - ${convertSingleTime(end)}`;
    };
    return timeRange
        .split(",")
        .map((range) => range.trim())
        .filter(Boolean)
        .map(convertRange)
        .filter(Boolean)
        .join(" \u00A0▪\u00A0 ");
};
export const setDiscountImageUrl = (category) => {
    const imageMap = {
        BILL_DISCOUNT: "bill.png",
        TABLE_DISCOUNT: "chair_table.png",
        COMBOS: "combo.png",
    };
    const imageName = imageMap[category] || "food-drink.png";
    return `${IMG_URL}/icons/${imageName}`;
};
export const capitalizeWords = (str) => {
    if (!str || typeof str !== "string")
        return str;
    return str
        .trim()
        .split(/\s+/)
        .map((word) => word.length > 0 && /^[a-zA-Z]/.test(word)
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : word)
        .join(" ");
};
/**
 * Returns the short display bill number for UI (e.g. 1001) when available,
 * otherwise falls back to the full bill_number. Use for display only; keep
 * bill_number for API calls.
 */
export const getDisplayBillNumber = (bill) => {
    var _a, _b, _c;
    if (!bill)
        return "—";
    const display = (_a = bill.display_bill_number) !== null && _a !== void 0 ? _a : bill.displayBillNumber;
    if (display != null)
        return String(display);
    return (_c = (_b = bill.bill_number) !== null && _b !== void 0 ? _b : bill.billNumber) !== null && _c !== void 0 ? _c : "—";
};
export function customCapitalize(input) {
    if (!input)
        return "";
    const words = input.split(" ");
    // Process each word
    const processedWords = words.map((word) => {
        // Check if the word contains /, or -
        if (word.includes("/") || word.includes(",") || word.includes("-")) {
            // Split by /, or - and process each part
            const separators = ["/", ",", "-"];
            let result = word;
            // Process for each separator
            for (const separator of separators) {
                if (word.includes(separator)) {
                    const parts = result.split(separator);
                    const capitalizedParts = parts.map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase());
                    result = capitalizedParts.join(separator);
                }
            }
            return result;
        }
        else {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
    });
    // Join the words back together
    return processedWords.join(" ");
}
export const removeAllOtherRefs = () => {
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("z_ref_")) {
            localStorage.removeItem(key);
            i--;
        }
    }
};
export const removeAllOtherPartnerId = () => {
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("z_partnerId_")) {
            localStorage.removeItem(key);
            i--;
        }
    }
};
export const stringToAmPm = (timeStr) => {
    if (!timeStr)
        return "";
    const [hourStr = "0", minuteStr = "0"] = timeStr.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute.toString().padStart(2, "0")} ${ampm}`;
};
export const getPriceRange = (item) => {
    let min = Number.POSITIVE_INFINITY;
    let max = 0;
    let allPasses = [];
    const collectPasses = (entity) => {
        if ("has_pass_groups" in entity || "direct_passes" in entity) {
            const slot = entity;
            if (slot.has_pass_groups && slot.pass_groups) {
                slot.pass_groups.forEach((group) => {
                    if (group.enabled && group.passes) {
                        allPasses = allPasses.concat(group.passes.filter((pass) => pass.status === "ACTIVE" && !pass.is_walkin_only));
                    }
                });
            }
            if (slot.direct_passes) {
                allPasses = allPasses.concat(slot.direct_passes.filter((pass) => pass.status === "ACTIVE" && !pass.is_walkin_only));
            }
        }
        else if ("has_sub_events" in entity) {
            const event = entity;
            if (event.has_sub_events && event.sub_events) {
                event.sub_events.forEach((subEvent) => {
                    if (subEvent.enabled) {
                        collectPasses(subEvent);
                    }
                });
            }
            if (event.direct_slots) {
                event.direct_slots.forEach((slot) => {
                    if (slot.enabled) {
                        collectPasses(slot);
                    }
                });
            }
        }
        else if ("passes" in entity && "enabled" in entity) {
            const passGroup = entity;
            if (passGroup.enabled && passGroup.passes) {
                allPasses = allPasses.concat(passGroup.passes.filter((pass) => pass.status === "ACTIVE" && !pass.is_walkin_only));
            }
        }
        else {
            const subEvent = entity;
            if (subEvent.enabled && subEvent.slots) {
                subEvent.slots.forEach((slot) => {
                    if (slot.enabled) {
                        collectPasses(slot);
                    }
                });
            }
        }
    };
    collectPasses(item);
    allPasses.forEach((pass) => {
        if (pass.booking_prices) {
            const price = (pass.booking_prices.entry - pass.booking_prices.entry_discount || 0) +
                (pass.booking_prices.cover - pass.booking_prices.cover_discount || 0);
            if (price < min)
                min = price;
            if (price > max)
                max = price;
        }
    });
    if (min === Number.POSITIVE_INFINITY || allPasses.length === 0) {
        return { priceText: "", isSinglePass: false, minPrice: null };
    }
    const isSinglePass = allPasses.length === 1;
    if (min === 0 && max === 0) {
        return { priceText: "Free", isSinglePass, minPrice: 0 };
    }
    if (min === max) {
        return {
            priceText: min === 0 ? "Free" : `₹${min}`,
            isSinglePass,
            minPrice: min,
        };
    }
    // Show only minimum price to attract customers
    const priceText = min === 0 ? "Free" : `₹${min} onwards`;
    return { priceText, isSinglePass: false, minPrice: min };
};
export const getPassGroupTagBg = (index) => {
    const preset = [
        "linear-gradient(90deg, #C3A719 0%, #F3CF21 100%)",
        "linear-gradient(90deg, #8155FE 0%, #A383FF 100%)",
        "linear-gradient(276.58deg, #CF2A5E 4.75%, #A60135 89.62%)",
    ];
    if (index < preset.length)
        return preset[index];
    // Generate a unique, dark gradient for each index
    const hue1 = (index * 83) % 360; // Large step for uniqueness
    const hue2 = (hue1 + 40) % 360;
    const sat1 = 65 + ((index * 7) % 20); // 65-85%
    const sat2 = 60 + ((index * 13) % 25); // 60-85%
    const light1 = 22 + ((index * 3) % 10); // 22-32% (darker)
    const light2 = 28 + ((index * 5) % 12); // 28-40% (darker)
    return `linear-gradient(90deg, hsl(${hue1}, ${sat1}%, ${light1}%) 0%, hsl(${hue2}, ${sat2}%, ${light2}%) 100%)`;
};
export const shareArtistProfile = async (artist) => {
    var _a;
    if (!artist)
        return;
    const uuid = artist.partnerUuid
        ? artist.partnerUuid
        : artist.uuid;
    const shareUrl = `https://zillout.com/partner/view/${uuid}`;
    if (navigator === null || navigator === void 0 ? void 0 : navigator.share) {
        try {
            await (navigator === null || navigator === void 0 ? void 0 : navigator.share({
                title: (artist === null || artist === void 0 ? void 0 : artist.name) || "Check this artist",
                url: shareUrl,
            }));
        }
        catch (error) {
            console.error("Share failed", error);
        }
    }
    else {
        try {
            await ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(shareUrl));
        }
        catch (err) {
            console.log(err);
        }
    }
};
export const formatEventTimeOnly = (startISO, endISO) => {
    const start = new Date(startISO);
    const end = new Date(endISO);
    const opts = { hour: "numeric", minute: "2-digit", hour12: true };
    const startTime = start
        .toLocaleTimeString(undefined, opts)
        .replace(/^0/, "")
        .replace("AM", "AM")
        .replace("PM", "PM");
    const endTime = end
        .toLocaleTimeString(undefined, opts)
        .replace(/^0/, "")
        .replace("AM", "AM")
        .replace("PM", "PM");
    return `${startTime} – ${endTime}`;
};
export const calculatePrice = (coverPrice, entryPrice, discount, discountType) => {
    const total = coverPrice + entryPrice;
    if (discountType === "none")
        return total;
    const discountValue = discountType === "percentage"
        ? (total * discount) / 100
        : Math.min(discount, total);
    return total - discountValue;
};
export const getRecommendedAreaByLowestPrice = (tables = [], femaleCount = 0) => {
    if (!Array.isArray(tables) || tables.length === 0)
        return { areaName: "", tableType: "" };
    const areaMinPriceMap = {};
    const areaHasAccessibleTable = {};
    tables.forEach((table) => {
        var _a;
        if (!(table === null || table === void 0 ? void 0 : table.availableTables) || !(table === null || table === void 0 ? void 0 : table.areaName))
            return;
        const area = table.areaName;
        const minLadiesRequired = Number(table.minLadiesRequired) || 0;
        const isAccessible = minLadiesRequired === 0 || femaleCount >= minLadiesRequired;
        // Track if this area has at least one accessible table
        if (isAccessible) {
            areaHasAccessibleTable[area] = true;
        }
        // Only consider price if table is accessible
        if (isAccessible) {
            const price = calculatePrice(Number(table.coverPrice) || 0, Number(table.entryPrice) || 0, Number(table.discountValue) || 0, (_a = table.discountType) !== null && _a !== void 0 ? _a : "none");
            if (areaMinPriceMap[area] === undefined ||
                price < areaMinPriceMap[area].price) {
                areaMinPriceMap[area] = { price, tableType: table.tableType || "" };
            }
        }
    });
    let recommendedArea = "";
    let recommendedTableType = "";
    let lowestPrice = Infinity;
    // Only consider areas that have at least one accessible table
    Object.entries(areaMinPriceMap).forEach(([area, data]) => {
        if (areaHasAccessibleTable[area] && Number(data.price) < lowestPrice) {
            lowestPrice = Number(data.price);
            recommendedArea = area;
            recommendedTableType = data.tableType;
        }
    });
    return { areaName: recommendedArea, tableType: recommendedTableType };
};
export const getLowestCalculatedPriceByArea = (areaName, tables = []) => {
    if (!areaName || !Array.isArray(tables))
        return 9999999;
    const areaTables = tables.filter((t) => (t === null || t === void 0 ? void 0 : t.areaName) === areaName && (t === null || t === void 0 ? void 0 : t.availableTables) > 0);
    if (!areaTables.length)
        return 9999999;
    return Math.min(...areaTables.map((t) => {
        var _a;
        return calculatePrice(Number(t.coverPrice) || 0, Number(t.entryPrice) || 0, Number(t.discountValue) || 0, (_a = t.discountType) !== null && _a !== void 0 ? _a : "none");
    }));
};
export const normalizeKey = (val) => val
    .toLowerCase()
    .replace(/[\s_-]+/g, "")
    .trim();
export const normalize = (str = "") => str.trim().toLowerCase().replace(/\s+/g, " ");
/**
 * Generate area identifiers from tables data.
 * Returns both old format (just areaName) and new format (areaName_tableType) identifiers.
 * This supports backward compatibility with old SVG layouts while enabling new format.
 *
 * @param tables - Array of table objects with areaName and tableType
 * @returns Array of unique area identifiers in both formats
 */
export const generateAreaIdentifiers = (tables = []) => {
    const identifiers = new Set();
    tables.forEach((table) => {
        if (!table.areaName)
            return;
        const areaName = table.areaName.trim().toUpperCase();
        // Add the simple areaName for backward compatibility (old format)
        identifiers.add(areaName);
        // If tableType exists, also add the combined format (new format)
        if (table.tableType) {
            const tableType = table.tableType.trim().toUpperCase();
            identifiers.add(`${areaName}_${tableType}`);
        }
    });
    return Array.from(identifiers);
};
export const isValidNumericPrice = (price) => {
    if (price === null || price === undefined || price === "")
        return false;
    const numPrice = Number(price);
    return !isNaN(numPrice) && numPrice > 0;
};
export const shouldDisplayPrice = (price) => {
    if (price === null || price === undefined || price === "")
        return false;
    if (typeof price === "string" && price.trim() === "0")
        return false;
    const numPrice = Number(price);
    if (!isNaN(numPrice) && numPrice === 0)
        return false;
    return true;
};
export const formatPriceDisplay = (price, currency = "₹") => {
    if (price === null || price === undefined || price === "")
        return null;
    if (isValidNumericPrice(price)) {
        return `${currency}${Number(price).toLocaleString()}`;
    }
    return String(price);
};
export const getNumericPrice = (price) => {
    if (price === null || price === undefined || price === "")
        return NaN;
    if (typeof price === "string" && price.includes("/")) {
        const numericPart = price.split("/")[0].trim();
        const numPrice = Number(numericPart);
        return !isNaN(numPrice) && numPrice > 0 ? numPrice : NaN;
    }
    const numPrice = Number(price);
    return !isNaN(numPrice) && numPrice > 0 ? numPrice : NaN;
};
export const getMinLadiesByArea = (tables = []) => {
    return tables.reduce((result, item) => {
        const { areaName, tableType, minLadiesRequired } = item;
        if (!areaName || typeof minLadiesRequired !== "number")
            return result;
        // Add entry for base area name (old format: SUNDECK)
        if (result[areaName] === undefined ||
            minLadiesRequired < result[areaName]) {
            result[areaName] = minLadiesRequired;
        }
        // If tableType exists, also add entry for combined format (new format: SUNDECK_REGULAR)
        if (tableType) {
            const combinedKey = `${areaName}_${tableType}`;
            if (result[combinedKey] === undefined ||
                minLadiesRequired < result[combinedKey]) {
                result[combinedKey] = minLadiesRequired;
            }
        }
        return result;
    }, {});
};
